import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import clientsApi from "../../api/client/client";
import bookingApi from "../../api/booking/booking";
import appSettingApi from "../../api/appSetting/appSetting";
import apiClient from "../../api/client";
import { t } from "i18next";
import { ui } from "../../helpers/ui";

const InitHomeClientLogic = () => {
  const navigate = useNavigate();

  const [client, setClient] = useState<any>();
  const [appSettings, setAppSettings] = useState<any>(null);

  // Helper function to convert base64 to Uint8Array
  function urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  const subscribeToPushNotifications = async () => {
    const registration = await navigator.serviceWorker.ready;

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(
        "BPtMPh59wNDqiC59GqrdGYX4occjNcOBGwYBGj_0_fUxMoxsRTD8lU4XOpys4cZGQ0VfcFp5LFvRprQIvd03RuY",
      ), // You'll need a public VAPID key
    });

    // console.log('auth:', arrayBufferToBase64(subscription.getKey('auth')));

    // console.log('p256dh:', arrayBufferToBase64(subscription.getKey('p256dh')));

    // console.log('Push Subscription:', subscription);

    // await client.post("/send-push-notification", { message: "aab", title: "idemo", subscription })

    // Send the subscription to your server to store it and send push notifications later
    await apiClient.post<any>(`/save-subscription`, subscription);
    /* await fetch('/api/save-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(subscription),
    }); */
  };

  // Function to request notification permission
  const requestNotificationPermission = async () => {
    if ("Notification" in window) {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          console.log("Notification permission granted");
          // Call this function after the user has granted permission for notifications
          await subscribeToPushNotifications()
            .then()
            .catch((e) => console.log(e));
        } else {
          console.log("Notification permission denied");
        }
      } catch (error) {
        console.error("Error requesting notification permission", error);
      }
    }
  };

  const loadClient = () => {
    clientsApi
      .getMe()
      .then(async (response) => {
        if (response.status === 200) {
          if (response.data.bookings) {
            response.data.bookings = response.data.bookings.sort(
              (a: any, b: any) =>
                new Date(a.date).getTime() - new Date(b.date).getTime(),
            );
          }
          setClient(response.data);
          // Call this function when the app initializes or when the user is prompted
          await requestNotificationPermission();
        }
      })
      .catch((e) => {
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  const loadSettings = () => {
    appSettingApi
      .getSettings()
      .then((response) => {
        if (response.status === 200) setAppSettings(response.data);
      })
      .catch(() => {
        // Ne sme da obori home ako podesavanja ne stignu
      });
  };

  useEffect(() => {
    loadClient();
    loadSettings();
  }, []);

  const onSettings = async () => {
    navigate("/settings");
  };

  const onTrainings = () => {
    navigate("/bookings");
  };

  const onCancel = (id: number) => {
    bookingApi
      .cancel({ id })
      .then(() => {
        loadClient();
      })
      .catch((e) => {
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  return {
    client,
    appSettings,
    onSettings,
    onTrainings,
    onCancel,
  };
};

export default InitHomeClientLogic;
